import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.math.trunc.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import dayjs from 'dayjs';
export default {
  name: 'course_class_page',
  props: {
    currentCourse: {
      type: Object
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '课时',
        addFunName: 'eduLiyouCoureseClassAdd',
        modifyFunName: 'eduLiyouCoureseClassModify',
        delFunName: 'eduLiyouCoureseClassDel',
        queryFunName: 'eduLiyouCoureseClassQuery',
        detailFunName: 'eduLiyouCoureseClassDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        courseId: this.currentCourse.id
      },
      formData: {
        id: null,
        courseId: this.currentCourse.id,
        title: null,
        freeState: null,
        video: null,
        videoLength: null,
        videoTrackLength: null,
        audio: null,
        audioLength: null,
        audioTrackLength: null,
        remark: null,
        attachment: null
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序号不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '排序号必须为正整数',
          trigger: 'blur'
        }],
        freeState: [{
          required: true,
          message: '请选择是否免费',
          trigger: 'blur'
        }],
        video: [{
          required: true,
          message: '视频不能为空',
          trigger: 'blur'
        }],
        videoLength: [{
          required: true,
          message: '视频长度不能为空',
          trigger: 'blur'
        }],
        videoTrackLength: [{
          required: true,
          message: '视频长度(秒)不能为空',
          trigger: 'blur'
        }],
        audio: [{
          required: true,
          message: '音频不能为空',
          trigger: 'blur'
        }],
        audioLength: [{
          required: true,
          message: '音频长度不能为空',
          trigger: 'blur'
        }],
        audioTrackLength: [{
          required: true,
          message: '音频长度(秒)不能为空',
          trigger: 'blur'
        }],
        remark: [{
          required: true,
          message: '简介不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      VideoOrAudio: 'VideoAndAudio'
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    back: function back() {
      this.$emit('child-go-course');
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isVideo = ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'].includes(file.type);
      this.getTimes(file);
      if (!isVideo) {
        this.$message.error('文件必须是视频格式');
      }
      return isVideo;
    },
    beforeAudioUpload: function beforeAudioUpload(file) {
      var isVideo = ['audio/mp3', 'audio/ogg', 'audio/mpeg', 'video/ogg'].includes(file.type);
      this.getAudioTimes(file);
      if (!isVideo) {
        this.$message.error('文件必须是音频格式');
      }
      return isVideo;
    },
    uploadVideo: function uploadVideo(_ref) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this.formData.video = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    uploadAudio: function uploadAudio(_ref3) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.audio = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getTimes: function getTimes(file) {
      var _this3 = this;
      var content = file;
      var url = URL.createObjectURL(content);
      var audioElement = new Audio(url);
      audioElement.addEventListener('loadedmetadata', function (_event) {
        var numTime = parseInt(audioElement.duration);
        var strTime = '';
        if (numTime < 60) {
          strTime = '00:' + (numTime < 10 ? '0' + numTime : numTime);
        } else if (numTime > 60 && numTime % 60 !== 0) {
          strTime = (Math.trunc(numTime / 60) < 10 ? '0' + Math.trunc(numTime / 60) : Math.trunc(numTime / 60)) + ':' + (numTime % 60 < 10 ? '0' + numTime % 60 : numTime % 60);
        } else if (numTime % 60 === 0) {
          strTime = (numTime / 60 < 10 ? '0' + numTime / 60 : numTime / 60) + ':00';
        }
        _this3.formData.videoLength = strTime;
        _this3.formData.videoTrackLength = numTime;
      });
    },
    getAudioTimes: function getAudioTimes(file) {
      var _this4 = this;
      var content = file;
      var url = URL.createObjectURL(content);
      var audioElement = new Audio(url);
      audioElement.addEventListener('loadedmetadata', function (_event) {
        var numTime = parseInt(audioElement.duration);
        var strTime = '';
        if (numTime < 60) {
          strTime = '00:' + (numTime < 10 ? '0' + numTime : numTime);
        } else if (numTime > 60 && numTime % 60 !== 0) {
          strTime = (Math.trunc(numTime / 60) < 10 ? '0' + Math.trunc(numTime / 60) : Math.trunc(numTime / 60)) + ':' + (numTime % 60 < 10 ? '0' + numTime % 60 : numTime % 60);
        } else if (numTime % 60 === 0) {
          strTime = numTime / 60 + ':00';
        }
        _this4.formData.audioLength = strTime;
        _this4.formData.audioTrackLength = numTime;
      });
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    removeVideo: function removeVideo() {
      this.formData.video = '';
      this.formData.videoLength = '';
      this.formData.videoTrackLength = null;
    },
    removeAudio: function removeAudio() {
      this.formData.audio = '';
      this.formData.audioLength = '';
      this.formData.audioTrackLength = null;
    },
    uploadPdf: function uploadPdf(_ref5) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref5.file;
              _this5.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  var attachment;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this5.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file, true);
                      case 2:
                        attachment = _context5.sent;
                        console.log('attachment', attachment);
                        // this.formData.attachment = attachment.url
                        _this5.$set(_this5.formData, 'attachment', attachment.url);
                      case 5:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    pdfDel: function pdfDel() {
      this.attachment = {};
      this.formData.attachment = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this6 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this6.initFormData(res.data);
        _this6.editDialogTitle = _this6.pageConfig.editPageName + '维护';
        _this6.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this7 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this7.$api[_this7.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this7.$message.success('删除成功');
            _this7.query();
          } else {
            _this7.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this8 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this8.tableData = res.data || [];
        _this8.totalCount = res.count;
        _this8.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this9 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this9.formData.id) {
            _this9.$api[_this9.pageConfig.modifyFunName](_this9.saveFormDataProcess(_this9.formData)).then(function (res) {
              if (res.data) {
                _this9.$message.success('编辑成功');
                _this9.initFormData(_this9.emptyFormData);
                _this9.editDialogShow = false;
                _this9.query();
              } else {
                _this9.$message.error('编辑失败');
              }
            });
          } else {
            _this9.$api[_this9.pageConfig.addFunName](_this9.saveFormDataProcess(_this9.formData)).then(function (res) {
              if (res.data) {
                _this9.$message.success('新增成功');
                _this9.initFormData(_this9.emptyFormData);
                _this9.editDialogShow = false;
                _this9.query();
              } else {
                _this9.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};